<template>
  <div class="container">
    <div class="main-content">
      <div class="model-upload">
        <ModelUpload />
      </div>
      <div class="product-upload">
        <ProductUpload />
      </div>
    </div>
    <div class="category-list-wrapper">
      <img src="../../../assets/mirror_imgs/category_leftArrow.png"
           class="arrow left-arrow"
           @click="scrollLeft" />
      <div class="preview-list">
        <img v-for="altItem in altImages"
             :src="altItem.alt_image"
             @click="selectAttrImage(altItem.alt_image)" />
      </div>
      <img src="../../../assets/mirror_imgs/category_rightArrow.png"
           class="arrow right-arrow"
           @click="scrollRight" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useMirrorStore } from '../../../index'
import ModelUpload from './ModelPreview.vue'
import ProductUpload from './ProductPreview.vue'

const mirrorStore = useMirrorStore()

const previousAltImages = ref<any[]>([])

const altImages = computed(() => {
  const customableImages = (mirrorStore.productItem as any)?.customableImages
  if (customableImages && customableImages[0]?.altImages) {
    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    previousAltImages.value = customableImages[0].altImages
  }
  return previousAltImages.value
})


const selectAttrImage = (altImage: string) => {
  mirrorStore.previewClothing = altImage
}

const scrollLeft = () => {
  const categoryList = document.querySelector('.preview-list') as HTMLElement
  categoryList.scrollBy({ left: -100, behavior: 'smooth' })
}

const scrollRight = () => {
  const categoryList = document.querySelector('.preview-list') as HTMLElement
  categoryList.scrollBy({ left: 100, behavior: 'smooth' })
}
</script>

<style scoped lang="less">
.container {
  height: 100vh;
  /* 使容器占满屏幕高度 */
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  /* 为容器添加内边距 */
  box-sizing: border-box;
  /* 将padding包含在总高度内 */
}

.main-content {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 0 0 80%;
}

.model-upload,
.product-upload {
  background: url("../../../assets/mirror_imgs/category_border.png");
  background-size: 100% 100%;
  overflow: hidden;
  /* 调整间距，更灵活 */
}

.model-upload {
  flex: 0 0 50%;
}

.product-upload {
  flex: 0 0 48%;
  /* 设置较小的flex值，使其高度更小 */
}

.category-list-wrapper {
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.arrow {
  cursor: pointer;
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.left-arrow {
  margin-right: 10px;
}

.right-arrow {
  margin-left: 10px;
}

.preview-list {
  display: inline-flex;
  overflow: auto;
  width: calc(100% - 52px);
  /* 减去箭头部分的宽度 */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
}

.preview-list::-webkit-scrollbar {
  display: none;
  /* Safari and Chrome */
}

.preview-list img {
  max-width: 48px;
  max-height: 38px;
  background-size: cover;
  margin: 0 8px;
}
</style>
